export default import.meta.ROLLDOWN_FILE_URL_Jhiobz1iAIl42UC3k5$exQ